import React from 'react';
import { StatsCard } from '../components/StatsCard';
import { ChantierCard } from '../components/ChantierCard';
import { chantiers, clients } from '../utils/mockData';
import { Activity, AlertCircle, DollarSign, Clock, CheckCircle, Users } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../utils/auth';
export function Dashboard() {
  const navigate = useNavigate();
  const {
    user
  } = useAuth();
  // Calculate KPIs
  const chantiersActifs = chantiers.filter(c => ['en_cours', 'planifie', 'en_preparation'].includes(c.status)).length;
  const chantiersBloques = chantiers.filter(c => c.status === 'bloque').length;
  const chantiersFacturables = chantiers.filter(c => c.status === 'facturable').length;
  const enAttenteClient = chantiers.filter(c => c.status === 'en_attente_client').length;
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  const terminesCeMois = chantiers.filter(c => {
    if (c.status !== 'termine') return false;
    const endDate = new Date(c.endDate);
    return endDate.getMonth() === currentMonth && endDate.getFullYear() === currentYear;
  }).length;
  const uniqueTeamMembers = new Set();
  chantiers.filter(c => ['en_cours', 'planifie', 'en_preparation'].includes(c.status)).forEach(c => {
    uniqueTeamMembers.add(c.chefEquipeId);
    c.team.forEach(t => uniqueTeamMembers.add(t.id));
  });
  const equipesSurSite = uniqueTeamMembers.size;
  const recentChantiers = chantiers.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()).slice(0, 4);
  const strategicClients = clients.filter(c => c.isStrategicAccount);
  return <div className="min-h-screen bg-gray-50 pb-20 md:pb-6" data-id="element-529">
      <div className="page-container section-spacing" data-id="element-530">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-531">
          <div data-id="element-532">
            <h1 className="heading-xl" data-id="element-533">
              Bonjour, {user?.name.split(' ')[0]} 👋
            </h1>
            <p className="text-caption mt-1" data-id="element-534">
              Voici le résumé de l'activité France Décoration
            </p>
          </div>
          {(user?.role === 'admin' || user?.role === 'bureau') && <Button onClick={() => navigate('/chantiers/new')} leftIcon={<Activity size={18} data-id="element-536" />} data-id="element-535">
              Nouveau Chantier
            </Button>}
        </motion.div>

        {/* KPI Stats */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4" data-id="element-537">
          <StatsCard label="Chantiers Actifs" value={chantiersActifs} icon={Activity} color="teal" data-id="element-538" />
          <StatsCard label="Bloqués" value={chantiersBloques} icon={AlertCircle} color="red" data-id="element-539" />
          <StatsCard label="Facturables" value={chantiersFacturables} icon={DollarSign} color="purple" data-id="element-540" />
          <StatsCard label="Attente Client" value={enAttenteClient} icon={Clock} color="amber" data-id="element-541" />
          <StatsCard label="Terminés ce Mois" value={terminesCeMois} icon={CheckCircle} color="green" data-id="element-542" />
          <StatsCard label="Équipes sur Site" value={equipesSurSite} icon={Users} color="blue" data-id="element-543" />
        </motion.div>

        {/* Quick Client Filters */}
        {strategicClients.length > 0 && <motion.section initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} data-id="element-544">
            <h2 className="heading-md mb-4" data-id="element-545">Comptes Stratégiques</h2>
            <div className="flex flex-wrap gap-3" data-id="element-546">
              {strategicClients.map(client => <Button key={client.id} variant="outline" size="sm" onClick={() => navigate(`/clients/${client.id}`)} className="hover:border-[#1DBAB4] hover:text-[#1DBAB4]" data-id="element-547">
                  {client.raisonSociale}
                </Button>)}
            </div>
          </motion.section>}

        {/* Recent Chantiers */}
        <motion.section initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} data-id="element-548">
          <div className="flex items-center justify-between mb-6" data-id="element-549">
            <h2 className="heading-md" data-id="element-550">Chantiers Récents</h2>
            <Button variant="ghost" size="sm" onClick={() => navigate('/chantiers')} data-id="element-551">
              Voir tout
            </Button>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6" data-id="element-552">
            {recentChantiers.map((chantier, index) => <motion.div key={chantier.id} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4 + index * 0.1
          }} data-id="element-553">
                <ChantierCard chantier={chantier} data-id="element-554" />
              </motion.div>)}
          </div>
        </motion.section>
      </div>
    </div>;
}